import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/terms-of-service" className="footer-link">
            Terms of Service
          </Link>
          <span className="footer-separator">•</span>
          <Link to="/privacy-policy" className="footer-link">
            Privacy Policy
          </Link>
        </div>
        <div className="footer-copyright">
          <small>&copy; 2025 Serve Sync. All rights reserved.</small>
        </div>
      </div>
    </footer>
  )
}

export default Footer
